module.exports = __webpack_public_path__ + "media/images/article/file-alt-ae74130c48cd1888b77b85e0ceeb8b3f.svg";